import { SxProps, Theme } from '@mui/material';
import { t } from 'i18next';

import { spacing } from '~theme/AppTheme';

type JobsTableColumn = {
  key: string;
  size: string;
  sx?: SxProps<Theme>;
  title?: string;
};

export const columns: JobsTableColumn[] = [
  {
    key: 'checkbox',
    size: `calc(20px + ${spacing(2)})`,
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'driver_and_truck',
    title: `${t('approvals.files.jobs_table.headers.driver_and_truck')}`,
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'requested_equipment_type',
    title: `${t('dispatch.dispatch_v2.requested_equipment_type')}`,
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'status',
    title: `${t('approvals.files.jobs_table.headers.status')}`,
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'time_and_duration',
    title: `${t('approvals.files.jobs_table.headers.time_and_duration')}`,
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'loads',
    title: `${t('approvals.files.jobs_table.headers.loads')}`,
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'total_quantity',
    title: `${t('approvals.files.jobs_table.headers.total_quantity')}`,
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'receivables',
    title: `${t('approvals.files.jobs_table.headers.receivables')}`,
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'payables',
    title: `${t('approvals.files.jobs_table.headers.payables')}`,
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'margin',
    title: `${t('approvals.files.jobs_table.headers.margin')}`,
    size: '1fr',
    sx: { p: 1, overflow: 'hidden' },
  },
  {
    key: 'actions',
    title: `${t('approvals.files.jobs_table.headers.actions')}`,
    size: `calc(140px + ${spacing(2)})`,
    sx: { p: 1, overflow: 'hidden' },
  },
];

export const gridTemplateColumns = columns.map((column) => column.size).join(' ');
